// Helpul documents
// https://coxautoinc.sharepoint.com/sites/department-user-experience/SitePages/Common%20Data%20Layer%20Variables%20schema%20for%20Google%20Tag%20Manager.aspx

import deepmerge from 'deepmerge';
export default function getDataLayer(dataLayer) {
  return deepmerge({
    // global brand/catalog specifier (atc, kbb)
    catalog: null,
    common: {
      application: {
        name: 'listings',
        environment: null
      },
      user: {
        // TODO: (INFOTRUST | Chris Weiss) example is yes/no, docs are 0,1,2 but what does that correspond to?
        // facebook = 2?
        isLoggedIn: 0,
        // TODO: (INFOTRUST | Chris Weiss) example is yes/no, docs are 0,1 but what does that correspond to? I assume atc is always 0?
        // Filter out internal users... maybe ip based?
        isInternalUser: false,
        // TODO: (INFOTRUST | Chris Weiss) What does this map to?
        // KBB only?
        // ivtMoatFlag: '1',
        type: 'consumer',
        // TODO: (INFOTRUST | Chris Weiss) What does this map to?
        // ATC_SID, JSESSION, pxa_id, ATC_ID?
        // Cat M may know? KBB may have their own
        consumerSessionId: '',
        zipCode: null,
        dma: null
      }
    },
    page: {
      // Autotrader page name (usually derived from @atc/bonnet-routes)
      pageName: null,
      siteSection: null,
      detailPageName: null,
      // A/B test platform experiment id
      // TODO: (INFOTRUST | Chris Weiss|DEV) we need to parse optimizely like we do in adobe?
      experimentId: null,
      // A/B test platform experiment variant
      // TODO: (INFOTRUST | Chris Weiss|DEV) we need to parse optimizely like we do in adobe?
      experimentVariant: null,
      type: '',
      pixallId: null,
      // TODO: (INFOTRUST | Chris Weiss) when does this apply and what is it?
      // set on VDP & DDP pages only
      // Malina?.
      dealershipId: null
    },
    search: {
      pagination: null,
      keyword: null,
      sortType: null,
      filters: {}
    },
    // Current page parsed search/query object
    query: {},
    // Defined device data
    device: {},
    // Aggregated and fully hyderated collection of all inventory present on the page
    inventory: {},
    // Aggregated collection of all owners present on the page
    owners: {},
    // fully hyderated listing property for VDP like pages
    vehicle: null
  }, dataLayer);
}